import { combineReducers } from "redux";
import StoreFetch from "./OnBoarding/StoreFetch";
import StoreAdd from "./OnBoarding/StoreAdd";
import StoreUpdate from "./OnBoarding/StoreUpdate";
import Products from "./OnBoarding/Products";
import ProductsCount from "./OnBoarding/ProductsCount";
import StoreSyncOrder from "./OnBoarding/StoreSyncOrders";
import StoreSyncProduct from "./OnBoarding/StoreSyncProducts";
import StoreSyncMeta from "./OnBoarding/StoreSyncMeta";
import StoreTemp from "./OnBoarding/StoreTemp";
import userDetailsReducer from "./OnBoarding/UserDetails";
import addressDetailsReducer from "./OnBoarding/AddressDetails";
import finishLaterReducer from "./OnBoarding/FinishLater";
import User from "./User/User";
import Rates from "./Order/Rates";
import Orders from "./OnBoarding/Orders";
import SkipChannel from "./OnBoarding/SkipChannel";
import AddOrder from "./Order/AddOrder";
import addOrderAddressDetailsReducer from "./Order/ShipToAddress";
import addOrderPackageDetailsReducer from "./Order/ShipInfo";
import addOrderProductDetailsReducer from "./Order/ProductDetails";
import OrderDimensionUpdate from "./Order/UpdateOrderDimension";
import GetOrder from "./Order/GetOrder";
import BuyPickup from "./PickUP/BuyPickup";
import OrderTracking from "./Tracking/OrderTracking";
import GeoCodeLocation from "./HereMaps/GeoCode";
import RateByOrder from "./Order/RatesByOrder";
import QuickRateReducer from "./Order/QuickRates";
import buyLabel from "./Shipment/BuyLabel";
import ShipmentByOrderReducer from "./Shipment/ShipmentOrder";
import pickupRateReducer from "./PickUP/PickupRates";
import downloadLabelReducer from "./Shipment/DownloadLabel";
import getOrderPlacedReducer from "./Order/OrderPlaced";
import createOrderData from "./Order/CreateOrder";
import allAddressesData from "./OnBoarding/AllAddresses";
import getEasyPostTrackingReducer from "./Tracking/EasyPostTracking";
import OrderCountReducer from "./Order/OrderCount";
import countryReducer from "./Utility/Country";
import warehouseReducer from "./Utility/WareHouse";
import getOrderWithDetailsReducer from "./Order/OrderWithProductDetails";
import navigationReducer from "./Utility/Navigation";
import updateAddressReducer from "./AddressManager/UpdateAddress";
import getAddressReducer from "./AddressManager/GetAddress";
import getAddressByIdReducer from "./AddressManager/GetAddressById";
import addAddressReducer from "./AddressManager/AddAddress";
import updateAddressDefaultReducer from "./AddressManager/UpdateAddressDefault";
import updateAddressStatusReducer from "./AddressManager/UpdateAddressStatus";
import ShipmentFeesDetailsReducer from "./Shipment/ShipmentFeesDetails";
import PurchaseShipmentReducer from "./Shipment/Payment";
import getAddressByCategoryReducer from "./AddressManager/GetAddressByCategory";
import getBatchOrderReducer from "./Shipment/BatchOrders";
import BatchOrderCountReducer from "./Shipment/BatchOrdersCount";
import batchShipmentReducer from "./Shipment/BatchShipment";
import batchTableDataReducer from "./Shipment/BatchTableData";
import createShipmentData from "./Order/CreateShipment";
import cancelOrderData from "./Order/CancelOrder";
import downloadBatchLabelReducer from "./Shipment/DownloadBatchLabel";
import orderDimensionUpdateReducer from "./Order/UpdateOrderDimension";
import chooseCarrierReducer from "./Order/AddOrder";
import fileUploadReducer from "./Order/BulkUpload";
import fileStatusReducer from "./Order/BulkUploadInfo";
import createWalletData from "./Wallet/CreateWallet";
import getWalletDetailsReducer from "./Wallet/GetWalletDetails";
import shipmentCountReducer from "./Shipment/ShipmentCount";
import ShipmentListReducer from "./Shipment/ShipmentList";
import shipmentNdrReducer from "./Shipment/ShipmentNdr";
import searchShipmentReducer from "./Shipment/SearchShipment";
import getStoreDataReducer from "./OnBoarding/GetStoreData";
import getBatchOrderByIdReducer from "./Shipment/GetBatchByBatchId";
import downloadErrorReducer from "./Shipment/DownloadError";
import checkBatchStatusReducer from "./Shipment/DownloadBatchStatus";
import getPackageBoxesReducer from "./Configuration/GetPackageBoxes";
import addPackageBoxesReducer from "./Configuration/AddPackageBox";
import updatePackageBoxesReducer from "./Configuration/UpdatePackageBox";
import getActivityLogsReducer from "./Order/ActivityLog";
import getChannelDataReducer from "./ChannelConfig/GetChannelData";
import saveChannelDataReducer from "./ChannelConfig/SaveChannelData";
import updateChannelDataReducer from "./ChannelConfig/UpdateChannelData";
import getBulkActionsListReducer from "./BulkActions/BulkActionList";
import sendBulkLabelDetailsReducer from "./BulkActions/CreateBulkLabel";
import getBulkLabelDownloadReducer from "./BulkActions/BulkLabelDownlod";
import getBulkErrorDownloadReducer from "./BulkActions/BulkErrorDownload";
import checkBulkStatusReducer from "./BulkActions/BulkDownloadStatus";
import bulkOrderCountReducer from "./BulkActions/BulkOrdersCount";
import addShipmentLabelReducer from "./ShipmentLabel/AddShipmentLabel";
import getShipmentLabelReducer from "./ShipmentLabel/GetShipmentLabel";
import UpdateEmailNotificationreducer from "./Notification/UpdateEmailNotification";
import getEmailNotificationReducer from "./Notification/GetEmailNotification";
import getWhatsappNotificationReducer from "./Notification/GetWhatsappNotification";
import UpdateWhatsappNotificationreducer from "./Notification/UpdateWhatsappNotification";
import weightDiscrepancyfileUploadReducer from "./AdminPanel/UploadWeightDiscrepancy";
import codRemittancefileUploadReducer from "./AdminPanel/UploadCodRemittance";
import getOrdersByStatusReducer from "./Order/GetOrdersByStatus";
import getWhatsappSummaryReducer from "./Notification/GetWhatsappSummary";
import EnableWhatsappNotificationreducer from "./Notification/EnableWhatsappNotification";
import CreateWhatsappTrialMessagereducer from "./Notification/CreateTrialMessage";
import brandImageUploadReducer from "./Notification/UploadBrandImage";
import getMessageCountReducer from "./Notification/GetMessageCount";
import OrderByStatusCountReducer from "./Order/GetOrdersByStatusCount";
import markRtoReceivedDetailsReducer from "./Order/MarkRtoReceived";
import invoicingLogReducer from "./AdminPanel/GetInvoicingDetails";
import downloadInvoicingReportData from "./AdminPanel/InvoicingFileDownload";
import finalChargesLogReducer from "./AdminPanel/GetFinalChargesDetails";
import downloadFinalChargesReportData from "./AdminPanel/FinalChargesFileDownload";
import UpdateUtrNumberReducer from "./AdminPanel/UpdateUtrNumber";
import getRateConfigsReducer from "./RateManagement/GetRateConfigs";
import getDefaultCarriersReducer from "./RateManagement/GetDefaultCarriers";
import saveDefaultCarriersReducer from "./RateManagement/SaveDefaultCarriers";
import sendRateConfigsReducer from "./RateManagement/SendRateConfigs";
import getZoneRateReducer from "./RateManagement/GetZoneRateFile";
import getZoneMappingReducer from "./RateManagement/GetZoneMappingFile";
import uploadZoneMappingReducer from "./RateManagement/UploadZoneMappingFile";
import uploadZoneRateReducer from "./RateManagement/UploadZoneRateFile";
import getActiveCarriersReducer from "./RateManagement/GetActiveCarriers";
import getTenantListReducer from "./OnBoarding/TenantList";
import GenerateShipmentChargesReducer from "./AdminPanel/GenerateShipmentCharges";
import GenerateFinalChargesReducer from "./AdminPanel/GenerateFinalCharges";
import tenanatManagerLogData from "./TenantManager/TenantManagerLog";
import UpdateAdminRechargereducer from "./TenantManager/AdminRecharge";
import addTagsReducer from "./Order/AddTags";
import getRiskScoreChargesReducer from "./VasCharges/getRiskScoreCharges";
import getWhatsappConfirmationChargesReducer from "./VasCharges/getWhatsAppConfirmationCharges";
import getWhatsappChargesReducer from "./VasCharges/getWhatsAppCharges";
import updateRiskScoreChargesReducer from "./VasCharges/updateRiskScoreCharges";
import updateWhatsappChargesReducer from "./VasCharges/updateWhatsAppCharges";
import updateWhatsappConfirmationChargesReducer from "./VasCharges/updateWhatsAppConfirmationCharges";
import updateVasControlDataReducer from "./VasCharges/updateVasControlData";
import getVasControlDataReducer from "./VasCharges/getVasControlData";
import updateWhatsappNotificationChargesReducer from "./VasCharges/updateWhatsappNotificationCharges";
import getWeightDisputeImageReducer from "./WeightDiscrepancy/DownloadWeightDisputeImage";
import getWeightDiscrepancyAggregateReducer from "./WeightDiscrepancy/GetWeightDiscrepancyAggregate";
import getWeightDiscrepancyDataReducer from "./WeightDiscrepancy/GetWeightDiscrepancyData";
import weightDisputeFileUploadReducer from "./WeightDiscrepancy/WeightDisputeUpload";
import updateWeightDisputeReducer from "./WeightDiscrepancy/UpdateWeightDispute";
import closeWeightDisputeReducer from "./WeightDiscrepancy/CloseWeightDispute";
import getSellerWalletPlansReducer from "./TenantManager/GetSellerWalletPlans";
import getActiveWalletPlanReducer from "./TenantManager/GetActiveWalletPlan";
import updateActiveWalletPlanReducer from "./TenantManager/UpdateSellerWalletPlan";
import getProfilesReducer from "./OnBoarding/GetProfile";
import updateKYCstateReducer from "./OnBoarding/UpdateKYCstate";
import fetchBillingDatesData from "./AdminPanel/BillingDates";
import getActiveAccountTypeReducer from "./TenantManager/GetAccountType";
import updateActiveAccountTypeReducer from "./TenantManager/UpdateAccountType";
import getEarlyCODChargesReducer from "./VasCharges/getEarlyCODCharges";
import updateEarlyCODChargesReducer from "./VasCharges/updateEarlyCODCharges";
import getRemittnacePayoutCycleReducer from "./TenantManager/GetRemittancePayoutCycle";
import updateRemittnacePayoutCycleReducer from "./TenantManager/UpdateRemittancePayoutCycle";
import getWhatsappNdrVerificationChargesReducer from "./VasCharges/getWhatsappNdrVerificationCharges";
import updateWhatsappNdrVerificationChargesReducer from "./VasCharges/updateWhatsappNdrVerificationCharges";
import getBulkWeightDiscrepancyDataReducer from "./WeightDiscrepancy/GetBulkWeightDiscrepancyData";
import getBulkWeightDiscrepancyCountReducer from "./WeightDiscrepancy/GetBulkWeightDiscrepancyCount";
import uploadImageByCarrierReducer from "./WeightDiscrepancy/UploadImageByCarrier";
import getIVRNdrChargesReducer from "./VasCharges/getIVRndrCharges";
import getIVRORDERChargesReducer from "./VasCharges/getIVRorderCharges";
import deactivateVasControlDataReducer from "./VasCharges/deactivateVasService";
import getOTPverifiedDeliveryChargesReducer from "./VasCharges/getOtpVerifiedDeliveryCharges";
import downloadErrorFileReducer from "./AdminPanel/DownloadErrorFile";
import getCarrierListReducer from "./RateCard/GetCarrierList";
import getCarrierRateReducer from "./RateCard/GetRates";
import downloadPaymentReportData from "./Payment/RequestReportDownload";
import updateB2BMisReducer from "./B2BMis/UpdateB2BMis";
import getCompanyMetaDataReducer from "./TenantManager/GetCompanyMetaData";
import getKycInfoReducer from "./TenantManager/GetKycInfo";
import getDeclarationFormReducer from "./OnBoarding/DownloadDeclarationForm";
import updateDeclarationFormstateReducer from "./OnBoarding/UpdateDeclarationStatus";
import getDeclarationStatusReducer from "./OnBoarding/GetDeclarationStatus";
import getPendingRechargeRequestsReducer from "./RechargeApproval/GetPendingRechargeRequests";
import getDecidedRechargeRequestsReducer from "./RechargeApproval/GetDecidedRechargeRequests";
import approveRechargeReducer from "./RechargeApproval/ApproveRecharge";
import rejectRechargeReducer from "./RechargeApproval/RejectRecharge";
import getApproversReducer from "./RechargeApproval/GetApprovers";
import addApproverReducer from "./RechargeApproval/AddApprover";
import removeApproverReducer from "./RechargeApproval/RemoveApprover";
import getUserInfoReducer from "./User/GetUserInfo";
import getCompanyInfoReducer from "./TenantManager/GetCompanyInfo";
import getGSTCertificateListReducer from "./OnBoarding/GetGSTcertList";
export default combineReducers({
    userDetailsReducer,
    addressDetailsReducer,
    User,
    StoreFetch,
    StoreAdd,
    StoreUpdate,
    StoreSyncOrder,
    StoreSyncProduct,
    StoreSyncMeta,
    StoreTemp,
    Products,
    Orders,
    ProductsCount,
    finishLaterReducer,
    Rates,
    RateByOrder,
    AddOrder,
    addOrderAddressDetailsReducer,
    addOrderPackageDetailsReducer,
    addOrderProductDetailsReducer,
    OrderDimensionUpdate,
    GetOrder,
    ShipmentFeesDetailsReducer,
    OrderTracking,
    GeoCodeLocation,
    BuyPickup,
    BuyLabel: buyLabel,
    ShipmentByOrderReducer,
    pickupRateReducer,
    downloadLabelReducer,
    getOrderPlacedReducer,
    createOrderData,
    allAddressesData,
    getEasyPostTrackingReducer,
    OrderCountReducer,
    SkipChannel,
    countryReducer,
    warehouseReducer,
    getOrderWithDetailsReducer,
    navigationReducer,
    QuickRateReducer,
    updateAddressReducer,
    getAddressReducer,
    getAddressByIdReducer,
    addAddressReducer,
    updateAddressDefaultReducer,
    updateAddressStatusReducer,
    PurchaseShipmentReducer,
    getAddressByCategoryReducer,
    getBatchOrderReducer,
    BatchOrderCountReducer,
    batchShipmentReducer,
    batchTableDataReducer,
    createShipmentData,
    cancelOrderData,
    downloadBatchLabelReducer,
    orderDimensionUpdateReducer,
    chooseCarrierReducer,
    fileUploadReducer,
    fileStatusReducer,
    createWalletData,
    getWalletDetailsReducer,
    shipmentCountReducer,
    ShipmentListReducer,
    shipmentNdrReducer,
    searchShipmentReducer,
    getStoreDataReducer,
    getBatchOrderByIdReducer,
    downloadErrorReducer,
    checkBatchStatusReducer,
    getPackageBoxesReducer,
    addPackageBoxesReducer,
    updatePackageBoxesReducer,
    getActivityLogsReducer,
    getChannelDataReducer,
    saveChannelDataReducer,
    updateChannelDataReducer,
    getBulkActionsListReducer,
    sendBulkLabelDetailsReducer,
    getBulkLabelDownloadReducer,
    getBulkErrorDownloadReducer,
    checkBulkStatusReducer,
    bulkOrderCountReducer,
    addShipmentLabelReducer,
    getShipmentLabelReducer,
    UpdateEmailNotificationreducer,
    getEmailNotificationReducer,
    getWhatsappNotificationReducer,
    UpdateWhatsappNotificationreducer,
    weightDiscrepancyfileUploadReducer,
    codRemittancefileUploadReducer,
    getOrdersByStatusReducer,
    getWhatsappSummaryReducer,
    EnableWhatsappNotificationreducer,
    CreateWhatsappTrialMessagereducer,
    brandImageUploadReducer,
    getMessageCountReducer,
    OrderByStatusCountReducer,
    markRtoReceivedDetailsReducer,
    invoicingLogReducer,
    downloadInvoicingReportData,
    finalChargesLogReducer,
    downloadFinalChargesReportData,
    UpdateUtrNumberReducer,
    getRateConfigsReducer,
    getDefaultCarriersReducer,
    saveDefaultCarriersReducer,
    sendRateConfigsReducer,
    getZoneRateReducer,
    getZoneMappingReducer,
    uploadZoneMappingReducer,
    uploadZoneRateReducer,
    getActiveCarriersReducer,
    getTenantListReducer,
    GenerateShipmentChargesReducer,
    GenerateFinalChargesReducer,
    tenanatManagerLogData,
    UpdateAdminRechargereducer,
    addTagsReducer,
    getRiskScoreChargesReducer,
    getWhatsappConfirmationChargesReducer,
    getWhatsappChargesReducer,
    updateRiskScoreChargesReducer,
    updateWhatsappChargesReducer,
    updateWhatsappConfirmationChargesReducer,
    getVasControlDataReducer,
    updateVasControlDataReducer,
    updateWhatsappNotificationChargesReducer,
    getWeightDiscrepancyDataReducer,
    getWeightDiscrepancyAggregateReducer,
    weightDisputeFileUploadReducer,
    getWeightDisputeImageReducer,
    updateWeightDisputeReducer,
    closeWeightDisputeReducer,
    getSellerWalletPlansReducer,
    getActiveWalletPlanReducer,
    updateActiveWalletPlanReducer,
    getProfilesReducer,
    updateKYCstateReducer,
    fetchBillingDatesData,
    getActiveAccountTypeReducer,
    updateActiveAccountTypeReducer,
    getEarlyCODChargesReducer,
    updateEarlyCODChargesReducer,
    updateRemittnacePayoutCycleReducer,
    getRemittnacePayoutCycleReducer,
    getWhatsappNdrVerificationChargesReducer,
    updateWhatsappNdrVerificationChargesReducer,
    getBulkWeightDiscrepancyDataReducer,
    getBulkWeightDiscrepancyCountReducer,
    uploadImageByCarrierReducer,
    getIVRNdrChargesReducer,
    getIVRORDERChargesReducer,
    deactivateVasControlDataReducer,
    getOTPverifiedDeliveryChargesReducer,
    downloadErrorFileReducer,
    getCarrierListReducer,
    getCarrierRateReducer,
    downloadPaymentReportData,
    updateB2BMisReducer,
    getCompanyMetaDataReducer,
    getKycInfoReducer,
    getDeclarationFormReducer,
    updateDeclarationFormstateReducer,
    getDeclarationStatusReducer,
    getGSTCertificateListReducer,
    getPendingRechargeRequestsReducer,
    getDecidedRechargeRequestsReducer,
    approveRechargeReducer,
    rejectRechargeReducer,
    getApproversReducer,
    addApproverReducer,
    removeApproverReducer,
    getUserInfoReducer,
    getCompanyInfoReducer,
});
